const initialState = {
  fiscal_info: {
    vat: '',
    tax_number: '',
    billing_contact: {
      name: '',
      last_name: '',
      phone: '',
      email: '',
    },
  },
  payment_method: {
    payment_method: '',
    payment_term: {
      number_of_days: 30,
      payment_day: 30,
      IBAN: '',
      SEPA: '',
    },
  },
};

const initialStateForTest = {
  ...initialState,
};
export default initialState;
export { initialStateForTest };
